import { Injectable } from '@angular/core';
import { createState, select, Store, withProps } from '@ngneat/elf';
import {
  localStorageStrategy, persistState
} from '@ngneat/elf-persist-state';
import { User } from '../interfaces/user.interface';

export interface AuthProps {
  user: User | null;
  token: { token: string } | null;
}

const { state, config } = createState(withProps<AuthProps>({ user: null, token: null }));

const authStore = new Store({ state, name: 'auth', config });

export const persist = persistState(authStore, {
  key: 'auth',
  storage: localStorageStrategy,
});

@Injectable({ providedIn: 'root' })
export class AuthRepository {
  user$ = authStore.pipe(select((state) => state.user));
  token$ = authStore.pipe(select((state) => state.token));
  state$ = authStore.pipe(select((state) => {
    return {
      ...state,
      isLoggedId: Boolean(state.user?.id || false)
    }
  }));

  getState() {
    return authStore.getValue();
  }

  isLoggedIn(): boolean {
    return Boolean(this.getState().user?.id || false)
  }

  updateState(state: AuthProps) {
    authStore.update(() => (state))
  }

  updateUser(user: AuthProps['user']) {
    authStore.update((state) => ({
      ...state,
      user,
    }));
  }

  reset() {
    authStore.reset()
  }
}
